import React from "react";
import { StorageTypeContainer } from "../styled/selfService";
import { LuSnowflake, LuPackage, LuBriefcase } from "react-icons/lu";

const StorageType = ({
  transformValue,
  chosenStorage,
  setChosenStorage,
  total,
  pickupProduct,
  prices,
}) => {
  const storages = {
    0: "냉장",
    1: "상온",
    2: "캐리어",
  };

  const icons = {
    0: LuSnowflake,
    1: LuPackage,
    2: LuBriefcase,
  };

  const modeTitle = pickupProduct ? "픽업 보관 수량 선택" : "보관 수량 선택";
  const summaryTitle = pickupProduct
    ? "야구장 픽업할 보관 수량을 선택해주세요"
    : "보관 수량을 선택해주세요";
  const summaryDesc = pickupProduct
    ? "냉장, 상온, 캐리어 중 필요한 수량만 선택하면\n시간 제한 없이 맡기고 경기 종료 후 경기장 앞에서 픽업해요."
    : "냉장, 상온, 캐리어 중 필요한 수량만 선택한 뒤\n다음 단계로 진행해주세요.";

  const adjustValue = (key, increment) => {
    setChosenStorage((prev) => {
      const newValue = prev[key] + increment;
      return { ...prev, [key]: Math.max(newValue, 0) };
    });
  };

  return (
    <StorageTypeContainer
      className="slideContent storageTypeKiosk"
      style={{ transform: `translateX(${transformValue}%)` }}
    >
      <div className="topBar">
        <div className="topTitle">{modeTitle}</div>
        <div className="topTotal">
          선택 수량 <b>{total}</b>개
        </div>
      </div>

      <div className="storageGrid twoByTwo">
        {Object.entries(chosenStorage).map(([key, value]) => {
          const Icon = icons[key];

          return (
            <div
              key={key}
              className={`storageCard ${value > 0 ? "selected" : ""}`}
            >
              <div className="cardInner">
                <div className="cardTop">
                  <div className={`iconWrap iconType${key}`}>
                    <div className="icon">
                      <Icon />
                    </div>
                  </div>

                  <div className="name">{storages[key]}</div>
                  <div className="price">
                    {(prices?.[key] ?? 0).toLocaleString()}원
                  </div>
                </div>

                <div className="stepperRow">
                  <div className="stepper">
                    <button
                      type="button"
                      className="btn minus"
                      onClick={() => adjustValue(key, -1)}
                      aria-label={`${storages[key]} 감소`}
                    >
                      −
                    </button>

                    <div className="count" aria-label="수량">
                      {value}
                    </div>

                    <button
                      type="button"
                      className="btn plus"
                      onClick={() => adjustValue(key, 1)}
                      aria-label={`${storages[key]} 증가`}
                    >
                      +
                    </button>
                  </div>
                </div>
              </div>
            </div>
          );
        })}

        <div className="storageCard summaryCard">
          <div className="summaryInner">
            <div className="summaryBadge">안내</div>
            <div className="summaryTitle">{summaryTitle}</div>
            <div className="summaryDesc">
              {summaryDesc.split("\n").map((line, index) => (
                <React.Fragment key={line}>
                  {index > 0 && <br />}
                  {line}
                </React.Fragment>
              ))}
            </div>

            <div className="summaryTotalBox">
              <span>현재 선택</span>
              <strong>{total}개</strong>
            </div>
          </div>
        </div>
      </div>
    </StorageTypeContainer>
  );
};

export default StorageType;
